<!-- Desktop -->
<div class="latest-event d-none d-xl-flex" *ngIf="!env.isMobile">
    <div class="latest-event-item" *ngFor="let item of data;trackBy:trackByIndex;">
        <a class="new-launch-text" [routerLink]="['/game-detail', item?.event_id]" href=""><img alt="" src="https://speedcdn.io/assets/diamond-client-v8/icons/{{item?.event_type_id}}.png"><span>{{item?.name}}</span></a>
    </div>
</div>

<!-- Mobile -->
<div class="latest-event row" *ngIf="env.isMobile">
    <div class="latest-event-item" *ngFor="let item of data;trackBy:trackByIndex;">
        <a class="new-launch-text" [routerLink]="['/m/game-detail', item?.event_id]" href=""><img alt="" src="https://speedcdn.io/assets/diamond-client-v8/icons/{{item?.event_type_id}}.png"><span>{{item?.name}}</span></a>
    </div>
</div>